import axios from 'axios';
import parse from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import user from "../../Image/user.png";
import { BASE_URL } from '../../insightConfig/insightConfig';
import "./Slider.css";

function Slider() {
    const [testimonials, setTestimonials] = useState([]);

    useEffect(() => {
        axios.get(BASE_URL + "/testimonials")
            .then((response) => {
                setTestimonials(response.data.data);
            })
            .catch((error) => {
                console.error("Error fetching testimonials:", error);
            });
    }, []);

    useEffect(() => {
        if (testimonials.length > 0) {
            const Doctoritems = document.querySelectorAll('.carousel-laptop .item-laptop');
            Doctoritems.forEach((el) => {
                const minPerSlide = 4;
                let next = el.nextElementSibling;
                for (let i = 1; i < minPerSlide; i++) {
                    if (!next) {
                        next = Doctoritems[0];
                    }
                    let cloneChild = next.cloneNode(true);
                    el.appendChild(cloneChild.children[0]);
                    next = next.nextElementSibling;
                }
            });
        }
    }, [testimonials]);

    return (
        <div className='Carsousel_Container mb-3'>
            <div className='Carousel_heading'>
                <h1>Check out what IAS Toppers Have to say...</h1>
            </div>
            <div className='Carousel_Slider'>
                <div id="carouselExampleControl" className="carousel slide carousel-laptop" data-bs-ride="carousel">
                    <div className="carousel-inner inner-laptop">
                        {
                            testimonials.map((testimonial, index) => (
                                <div
                                    className={`carousel-item item-laptop Carousel-box me-3 ${index === 0 ? 'active' : ''}`}
                                    key={testimonial._id}
                                >
                                    <div className='col-md-6'>
                                        <div className="card text-center Slider-Container">
                                            <img
                                                src={testimonial.Image || user}
                                                className="card-img-top rounded-circle img-size"
                                                // alt={testimonial.ToperName}
                                                onError={(e) => e.target.src = user} // optional
                                            />
                                            <div className="card-body">
                                                <h5 className="card-title">{testimonial.ToperName}</h5>
                                                <p className="card-text">Rank {testimonial.Rank}, {testimonial.Position}-{testimonial.Year}</p>
                                                <p>{parse(testimonial.Message)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControl" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControl" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Slider;
